import { ProductCard } from 'src/pages/WelcomePage/ProductCard';
import { Link } from 'react-router-dom';
import { COSSUPORT_DEMO_PAGE, GETTING_STARTED_GUIDE } from 'src/shared/constants';
import baseImage from './welcome-page-img/knowledge-base.webp';
import agentImage from './welcome-page-img/ai-agent.webp';
import homeImage from './welcome-page-img/home-page.webp';
import { PATH_DASHBOARD, PATH_HOME } from 'src/constants/spa-routes';
import { ProductsType } from 'src/constants/products';

const CoIcon = () => {
  return (
    <svg width="52" height="31" viewBox="0 0 52 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.1105 0.000163361C12.0288 0.000163538 8.01495 1.63318 5.12875 4.53998C2.24254 7.44678 0.621093 11.3892 0.621093 15.5001C0.621093 19.6109 2.24254 23.5534 5.12875 26.4602C8.01495 29.367 12.0288 31 16.1105 31L16.1105 15.5001L16.1105 0.000163361Z"
        fill="#05050D"
      />
      <path
        d="M35.8887 0C44.4436 0 51.3789 6.93963 51.3789 15.5C51.3789 24.0603 44.4436 31 35.8887 31C27.3339 30.9999 20.3985 24.0602 20.3984 15.5C20.3984 6.93972 27.3338 0.000144427 35.8887 0ZM35.8516 9.14844C32.352 9.14844 29.5147 11.9873 29.5146 15.4893C29.5146 18.9912 32.352 21.8301 35.8516 21.8301C39.3509 21.8298 42.1875 18.9911 42.1875 15.4893C42.1875 11.9875 39.3509 9.14868 35.8516 9.14844Z"
        fill="#05050D"
      />
    </svg>
  );
};
const WelcomePage = () => {
  return (
    <div className="w-full flex p-5 h-screen bg-light">
      <div className="bg-white w-full h-full rounded-sm-5 flex flex-col items-center justify-center relative">
        <div className="flex flex-col items-center gap-2.5">
          <CoIcon />
          <p className="uppercase font-jamjuree font-bold text-2xl">Welcome to CoSupport AI Hub!</p>
        </div>
        <p className="font-jamjuree font-medium text-sm pt-6">
          Let’s get your first AI Agent up and running 🚀
        </p>
        <div className="flex gap-2.5 mt-4 w-full max-w-[950px]">
          <ProductCard
            buttonText="Create Knowledge Base"
            image={baseImage}
            arrowFill="#33FF71"
            className="bg-[#EEFFF4] border-[#E3E6E8]"
            link={PATH_DASHBOARD.AI_KNOWLEDGE_BASE}
          />
          <ProductCard
            image={agentImage}
            arrowFill="#A498FF"
            className="bg-[#EEF0FF] border-[#E3E6E8]"
            buttonText="Create AI Agent"
            link={`${PATH_DASHBOARD.PROJECTS_NEW_STEP_1}?type=${ProductsType.customer}`}
          />
          <ProductCard
            image={homeImage}
            arrowFill="#DFF800"
            className="bg-[#FAFFE0] border-[#E3E6E8]"
            buttonText="Open Home Page"
            link={PATH_HOME.ROOT}
          />
        </div>
        <div className="mt-6">
          <p className="text-center font-medium font-jamjuree text-sm">
            <span className="opacity-80">New to CoSupport AI? Make sure to check out the</span>{' '}
            <Link target={'_blank'} to={GETTING_STARTED_GUIDE} className="underline">
              <b>
                <i>Getting Started Guide</i>
              </b>
            </Link>
            . <br />
            <span className="opacity-80">
              Want an onboarding session? Feel free to schedule one
            </span>{' '}
            <Link target={'_blank'} to={COSSUPORT_DEMO_PAGE} className="underline">
              <b>
                <i>here</i>
              </b>
            </Link>
            .
          </p>
        </div>
        <p className="absolute bottom-10 opacity-50 text-xs font-jamjuree font-medium">
          CoSupport AI © {new Date().getFullYear()}.{' '}
          <a
            className="underline"
            href="https://cosupport.ai/privacy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>{' '}
          &{' '}
          <a
            className="underline"
            href="https://cosupport.ai/terms-of-services"
            target="_blank"
            rel="noreferrer"
          >
            Terms of Service
          </a>
        </p>
      </div>
    </div>
  );
};

export default WelcomePage;
